import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/scan",
    name: "scan",
    component: dashboard,
    redirect: {
      name: "statistics"
    },
    children: [
      {
        path: "statistics",
        name: "statistics",
        meta: { title: "扫码统计" },
        component: () => import("@/views/scan/statistics.vue"),
        children: [
          {
            path: "showScanInfo",
            name: "showScanInfo",
            meta: { title: "扫码统计详情" },
            component: () => import("@/views/scan/scanInfo.vue")
          }
        ]
      }
    ]
  }
];
